import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils/types";

export const LinkIcon = ({ className, ...props }: IconProps) => (
  <svg
    className={twMerge("size-5", className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.28593 10.0017L4.10741 11.1802C2.80567 12.4819 2.80567 14.5925 4.10741 15.8942C5.40916 17.196 7.51971 17.196 8.82146 15.8942L9.99997 14.7157M9.99997 5.28763L11.1785 4.10912C12.4802 2.80738 14.5908 2.80738 15.8925 4.10912C17.1943 5.41087 17.1943 7.52142 15.8925 8.82317L14.714 10.0017M7.64312 12.3589L12.3572 7.64481"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
